export const userStatus = {
    COMPLETE: 'פעיל',
    BLOCKED: 'x חסום',
    DELETED: 'x משתמש נמחק',
    INCOMPLETE: '-- לא הושלם',
    REGISTERED: 'משתמש רשום ללא הר הביטוח'
}

export const userRelations = {
    PARENT: 'הורה',
    CHILD: 'ילד',
    PARTNER: 'בן זוג'
}

export const userRoles = {
   customer : 'ליד',
    related: 'קרוב משפחה',
    subscriber: 'מנוי',
    agent: 'מפיץ',
    insurance_agent: 'סוכן ביטוח',
    money: 'כספים',
    collective: 'קולקטיב',
    distributors_manager: 'מנהל מוקד מכירות',
    sales: 'נציג מוקד מכירות',
    agent_moderator: ''
}
